// eslint-disable-next-line max-params
export const mutateHandlers = () => {}
